import "react";
import { jsx as r, jsxs as t } from "react/jsx-runtime";
var n = (o) => /* @__PURE__ */ r("svg", {
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...o,
  children: /* @__PURE__ */ t("g", {
    stroke: "#1e88e5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    children: [
      /* @__PURE__ */ r("circle", {
        cx: 12.0001,
        cy: 12,
        r: 9.00375
      }),
      /* @__PURE__ */ r("path", { d: "m10.9998 15.5014h2.3103" }),
      /* @__PURE__ */ r("path", { d: "m12.1593 15.5015v-4.2518h-1.1505" }),
      /* @__PURE__ */ r("path", { d: "m12.1002 8.24569c0 .13813-.112.25011-.2501.25011-.1382 0-.2501-.11198-.2501-.25011s.1119-.2501.2501-.2501" }),
      /* @__PURE__ */ r("path", { d: "m11.85 7.99558c.1381 0 .2501.11197.2501.2501" })
    ]
  })
});
export {
  n as default
};

//# sourceMappingURL=Information.js.map